export class FictitiousProfile {
  id: number;
  username: string;
  gender: string;
  seeking: string;
  city?: string;
  zip_code?: string;
  birthday: string;
  description: string;
  profile_image: string;
  body_build: string;
  hair_color: string;
  eye_color: string;
  interests: string[];
  civil_status?: string;
  height: string;
  online_status: number;
  show_online_status: number;
  private_location: number;
  is_favorite: boolean;
  avatar_image: {
    url: string;
    thumbnail_url: string;
  };
  gallery_images: {
    id: number;
    name: string;
    type: string;
    url: string;
    thumbnail_url: string;
    created_at: string;
  }[] = [];
}
